<div class="gmail-missing-avatars">
  <h1>Gmail users missing profile photos</h1>

  <p class="help">
    These users have a <code>&#64;gmail.com</code> address but no photo uploaded on the ladder
    (<code>Avatars</code> row missing or empty). To see their Google profile photo:
    use <strong>Open in Gmail</strong>, click the recipient in the compose header, then choose
    <strong>Open detailed view</strong> (or use <strong>Contacts search</strong>).
  </p>

  <div *ngIf="loading" class="text-muted">Loading…</div>
  <div *ngIf="error" class="alert alert-danger">{{ error }}</div>

  <p *ngIf="!loading && !error && users.length === 0" class="text-muted">
    No matching users.
  </p>

  <div *ngIf="!loading && users.length > 0">
    <p><strong>{{ users.length }}</strong> user(s)</p>
    <div class="table-responsive">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th>Name</th>
            <th>Nickname</th>
            <th>Email</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let u of users">
            <td>{{ displayName(u) }}</td>
            <td>{{ u.nickname || '—' }}</td>
            <td>{{ u.email }}</td>
            <td class="actions">
              <a class="btn btn-sm btn-primary me-1"
                 [href]="u.gmailComposeUrl"
                 target="_blank"
                 rel="noopener noreferrer">Open in Gmail</a>
              <a class="btn btn-sm btn-outline-secondary me-1"
                 [href]="u.contactsSearchUrl"
                 target="_blank"
                 rel="noopener noreferrer">Contacts search</a>
              <a class="btn btn-sm btn-link"
                 [routerLink]="['/player', u.userId]">Ladder profile</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <button type="button" class="btn btn-outline-secondary mt-2" (click)="load()" [disabled]="loading">
    Refresh
  </button>
</div>
